module.exports = __webpack_public_path__ + "img/business-badge.ce6d9d74.svg";